module.exports = __webpack_public_path__ + "static/02-card@2x-5fd9551ff3487dd8bf6d3446188117b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/02-card@2x.jpg
// module id = 2513
// module chunks = 168707334958949